import styled from 'styled-components';
import { palettes, FONT, BACKGROUND_GREY } from '../../styles/color';

type DateStyle = { background?: string, color?: string, textDecoration?: string };

export const dateStyleMapping: {[key: string]: DateStyle} = {
  availableTime: {
    background: palettes[3],
    color: 'white',
  },
  selectedTime: {
    background: palettes[5],
    color: 'white',
  },
  unavailableTime: {
    background: BACKGROUND_GREY,
    color: FONT,
    textDecoration: 'line-through',
  },
};

export const AvailableDateAndTimeBlock = styled.div`
  background: ${palettes[3]};
  color: white;
`;

export const TimeBlock = styled.div<DateStyle>`
  ${({ background }) => (`background: ${background};` || '')}
  ${({ color }) => (`color: ${color};` || '')}
  ${({ textDecoration }) => (`text-decoration: ${textDecoration};` || '')}
  margin: 0 3px;
`;
